import { render, staticRenderFns } from "./FullPage.vue?vue&type=template&id=2ea0c873&scoped=true&"
import script from "./FullPage.vue?vue&type=script&lang=ts&"
export * from "./FullPage.vue?vue&type=script&lang=ts&"
import style0 from "./FullPage.vue?vue&type=style&index=0&id=2ea0c873&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea0c873",
  null
  
)

export default component.exports